import { Typography } from '@pmi.web/react-common';
import { useTranslation } from 'react-i18next';

import { HelpSlide } from '../HelpSlide';

export function SlideAddProducts() {
  const { t } = useTranslation();

  return (
    <HelpSlide>
      <svg
        width="63"
        height="63"
        viewBox="0 0 63 63"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="4.84792"
          y="4.74614"
          width="52.5015"
          height="52.5015"
          rx="26.2508"
          stroke="#061423"
          strokeWidth="3.5001"
        />
        <path
          d="M32.7257 21.6476C32.7257 20.7348 31.9845 19.9935 31.0716 19.9935C30.1587 19.9935 29.4175 20.7348 29.4175 21.6476L29.4212 29.3413L21.7275 29.3449C20.8147 29.3449 20.0734 30.0861 20.0734 30.999C20.0734 31.9119 20.8147 32.6531 21.7275 32.6531L29.4212 32.6495L29.4248 40.3431C29.4248 41.2559 30.166 41.9972 31.0789 41.9972C31.9918 41.9972 32.733 41.2559 32.733 40.3431L32.7294 32.6495L40.423 32.6458C41.3358 32.6458 42.0771 31.9046 42.0771 30.9917C42.0771 30.0788 41.3358 29.3376 40.423 29.3376L32.7294 29.3413L32.7257 21.6476Z"
          fill="#061423"
        />
      </svg>
      <div
        style={{
          marginTop: 'var(--pmi-spacing-md)',
        }}
      >
        <Typography variant="h1">{t('Add Products')}</Typography>
      </div>
      <div style={{ marginTop: 'var(--pmi-spacing-xs)' }}>
        <Typography variant="p">
          {t('Fill your Virtual Warehouse inventory.')}
        </Typography>
      </div>
    </HelpSlide>
  );
}
